import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listLoyaltyTiers } from './api';
import {
  LIST_LOYALTY_TIERS_REQUEST,
  LOYALTY_TIER_REQUESTING,
  LIST_LOYALTY_TIERS_SUCCESS,
  RESET_LOYALTY_TIER_ISFETCHING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: LOYALTY_TIER_REQUESTING });
    const response = yield call(listLoyaltyTiers);
    yield put({
      type: LIST_LOYALTY_TIERS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_LOYALTY_TIER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_LOYALTY_TIERS_REQUEST, list);
}

export default function* loyaltyTierSagas() {
  yield all([watchList()]);
}
